<template>
  <md-card>
    <md-card-header>
      <h2>Asignar a Cuadrilla Trabajador</h2>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <!-- <h4 class="card-title"> Personal Disponible </h4> -->
        </div>

        <form
          class="md-layout-item"
          id="customer_staff_form"
          @submit.prevent="saveCustomerStaff()"
          v-if="workerJbUser && workerJbUser.length"
        >
          <div class="md-layout">
            <div v-if="!empty" class="md-layout-item md-size-100 md-medium-size-100">
              <md-field :class="validationClass('worker')">
                <label for="worker">Trabajador JB</label>
                <md-select
                  data-vv-name="worker"
                  v-validate="modelValidations.workerId"
                  v-model="updatedItem.worker"
                >
                  <md-option
                    v-for="wJB in workerJbUser"
                    :value="wJB.id"
                    :key="wJB.id"
                  >{{ wJB.name }}</md-option>
                </md-select>
              </md-field>
            </div>
            <div v-if="empty">
              <h4>No hay Personal Disponible</h4>
            </div>
          </div>
        </form>

        <loading-content
          v-else
          :loading="loading"
          empty-icon="people_outline"
          empty-label="Sin trabajadores disponible"
          empty-description="No existe personal asignable a cuadrilla."
        />
      </div>
    </md-card-content>
    <md-card-actions>
      <md-button v-if="empty" @click="closeNoData" class="md-warning">Cancelar</md-button>
      <md-button v-if="!empty" type="submit" form="customer_staff_form" class="md-success">Aceptar</md-button>
    </md-card-actions>
  </md-card>
</template>

<script>
import catalogService from "@/services/catalog";
import usersService from "@/services/user";

const modelValidations = {
  worker: {
    required: true,
  },
};

export default {
  name: "EditItem",

  components: {},

  props: {
    crewId: Number,
    actualWorkers: Array,
  },

  data() {
    return {
      loading: null,
      //MetaDatas
      typeWorker: [],
      workerJbUser: [],

      updatedItem: {},
      empty: false,
      touched: {
        name: false,
        codename: false,
      },
      modelValidations,
    };
  },
  methods: {
    closeNoData() {
      this.$emit("error");
    },

    saveCustomerStaff() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", this.updatedItem);
        }
      });
    },
    validationClass(field) {
      return [
        { "md-valid": !this.errors.has(field) && this.touched[field] },
        { "md-error": this.errors.has(field) },
      ];
    },

    consultMetasCatalogs(ruta, asign, arg) {
      // Make query for metaDatas
      catalogService.fetch(ruta, { id: arg, noStore: true }).then((res) => {
        this[asign] = res;
      });
    },

    comparer(otherArray) {
      return function (current) {
        return (
          otherArray.filter(function (other) {
            return other.JBuserId === current.id;
          }).length == 0
        );
      };
    },

    consultMetasUsers(ruta, asign, arg) {
      // Make query for metaDatas
      this.loading = true;
      usersService
        .fetchType(ruta)
        .then((res) => {
          this.loading = false;
          // let onlyInWorkers
          let onlyInUsers;
          if (this.actualWorkers.length !== 0) {
            // onlyInWorkers=this.actualWorkers.filter(this.comparer(res))
            onlyInUsers = res.filter(this.comparer(this.actualWorkers));
            this[asign] = onlyInUsers;
            if (onlyInUsers.length === 0) {
              this.empty = true;
            }
          } else {
            this[asign] = res;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.consultMetasUsers("crew", "workerJbUser");

    this.updatedItem = { crew: this.crewId };

    this.watchTouched({ updatedItem: Object.keys(modelValidations) });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/Crews/EditStaff.vue